require("./listing.scss");

(function ($) {
    $(function () {
        $(".carousel").carousel();

        if ($('body.bikesales').length) {
          hj('trigger', 'listing_control');
        };

        $(".badge").tooltip({
            html: true,
            title: function () {
                return $($(this).data("target")).html();
            }
        });

        $(".carousel.lazy").on("slide.bs.carousel",
            function (ev) {
                const lazy = $(ev.relatedTarget).find("img[data-src]");
                lazy.attr("src", lazy.data("src"));
                lazy.removeAttr("data-src");
            });

        $(".js-encode-search").on("click",
            function() {
                const id = $(this).closest(".listing-item").data("webm-networkid");
                const searchContext = encodeURIComponent(window.navigation.searchContext);

                const sort = encodeURIComponent(getUrlParameter("sort"));
                const offset = encodeURIComponent(getUrlParameter("offset"));
                const limit = encodeURIComponent(getUrlParameter("limit"));
                const encoded = `q=${searchContext}&sort=${sort}&offset=${offset}&limit=${limit}`;

                if (window.localStorage) {
                    window.localStorage.setItem(id, encoded);
                }
            });

        function getUrlParameter(name) {
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
            const results = regex.exec(window.location.search.toLowerCase());
            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        };
    });
})(jQuery);